import React, {useState} from 'react';
import PropTypes from 'prop-types';
import TagManagerService from 'services/TagManager';
import { actionsType } from 'config/constants';
import OrdersService from "services/Orders/";
import PubSub from 'services/PubSub/';
import InputText from'components/Forms/Inputs/InputText';
import Loader from 'components/Loader';

const ContentReschedule = (props) => {
    const orderId = props.orderId;
    const [addComment, setAddComment] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const _getConfirm = () => {
        setIsLoading(true);

        OrdersService.getOrderCancel(orderId, addComment).then((data) => {
            
            if (data && data.status === 200) {
                setIsLoading(false);
                setAddComment('');
                setTimeout(()=> PubSub.dispatch(actionsType.MODAL.RESCHEDULE_CONFIRM_CLOSE),0);

                setTimeout(() => {
                    PubSub.dispatch(actionsType.MODAL.ORDER_CANCEL_SUCCESS_OPEN)
                }, 0);

                TagManagerService.interaction('Anular', 'Confirmar', 'Mis Compras');
                TagManagerService.interaction('Anular', 'Cambio realizado', 'Mis Compras');
                if(props.success) props.success();
            } else {
                TagManagerService.interaction('Anular', 'No Realizado', 'Mis Compras');
            }
        });
    }

    const _onChange = (name, validate, value) => {
        setAddComment(value);
    }


    return (
        <div className={'new-modal-container'}>
            <div className={'new-modal-scroll'}>
                <div className='new-modal-title'>¿Quieres anular tu pedido?</div>
                <p className="content-reschedule-subtitle">Tu pedido no ha sido preparado aún, por lo que puedes anularlo si lo deseas.</p>
                <div className="content-reschedule-wrap-info">
                    <div className="content-reschedule-wrap-info-title">
                        <span className="content-reschedule-info-reason">Indícanos el motivo*</span>
                        <span className="content-reschedule-info-required">Obligatorio</span>
                    </div>

                    <div className="content-reschedule-wrap-textarea">
                        <InputText
                            label={''}
                            required={false}
                            placeholder={''} 
                            className="content-reschedule-textarea-input"
                            textArea={true}
                            maxLength={150}
                            defaultValue={addComment}
                            type={'text'}
                            callbackOnChange={_onChange}
                            callbackValidate={() => { return true}}
                            message={{
                                'error': 'error',
                            }}
                            counter={false}
                        />
                    </div>
                </div>
            </div>

            <div className={'modal-actions'}>
                <button className="secundary-btn btn-reschedule-cancel" onClick={()=> props.closeRescheduleMessage()}>Cancelar</button>
                <button className={(addComment ? ' primary-btn ' : ' disabled-btn ') + "btn-reschedule-confirm"} onClick={_getConfirm}>
                    {isLoading && <div className="loader-modal-order-cancel"><Loader /></div>}
                    {!isLoading && <span>Confirmar</span>}
                </button>
            </div>
        </div>
    )
}

ContentReschedule.propTypes = {
    closeRescheduleMessage: PropTypes.func,
    success: PropTypes.func,
    orderId: PropTypes.string
};

export default ContentReschedule;